import {BENEFIT_TYPE, mainServer} from '../../../../variables/config'
import FileSaver from 'file-saver';

export const request_delete_note = async (id,providerid) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  await mainServer.instance.delete('/patientnote/'+providerid)
  let response;
  response = await mainServer.instance.get("/patientnote/patient/"+id);
  return response.data.data.patient_notes
}

export const request_add_note = async (id,data) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  await mainServer.instance.post('/patientnote', data)
  let response;
  response = await mainServer.instance.get("/patientnote/patient/"+id);
  return response.data.data.patient_notes
}

export const request_delete_provider = async (id,providerid) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  await mainServer.instance.delete('/patientprovider/'+providerid)
  let response;
  response = await mainServer.instance.get("/patientprovider/patient/"+id);
  return response.data.data.patient_providers
}

export const request_add_provider = async (id,data) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  await mainServer.instance.post('/patientprovider', data)
  let response;
  response = await mainServer.instance.get("/patientprovider/patient/"+id);
  return response.data.data.patient_providers
}

export const request_patient_providers = async (id) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response;
  response = await mainServer.instance.get("/patientprovider/patient/"+id);
  return response.data.data.patient_providers
}

export const request_patient_notes = async (id) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response;
  response = await mainServer.instance.get("/patientnote/patient/"+id);
  return response.data.data.patient_notes
}

export const request_notes = async() => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response;
  response = await mainServer.instance.get("/patientnote/templates");
  return response.data.data.patient_note_templates
}






export const request_patient = async (id) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response;
  response = await mainServer.instance.get("/patient/"+id);
  return response.data.data.patient
}


export const request_patient_insurance = async (idpatient) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response = await mainServer.instance.get(`/patientinsurance/patient/${idpatient}/current`)
  return response.data.data.patient_insurance
}

export const request_hospital = async (id) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response;
  response = await mainServer.instance.get("/hospital/"+id);
  return response.data.data.hospital
}


export const request_change_approval_status = async (id, data) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  const url = '/patient/'+id+'/approvalstatus'
  await mainServer.instance.post(url, data)
  let response;
  response = await mainServer.instance.get("/patient/"+id);
  return response.data.data.patient
}


export const request_approve_product = async (id) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  const url = '/patientproduct/'+id+'/approve'
  await mainServer.instance.post(url)
}

export const request_edit_patient = async (id,data) => {
  const logData = JSON.parse(localStorage.getItem('data'))
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token
  await mainServer.instance.patch("/patient/"+id, data)
  let response
  response = await mainServer.instance.get("/patient/"+id);
  return response.data.data.patient
}

export const request_products = async(params) => {
  const logData = JSON.parse(localStorage.getItem('data'))
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token
  let response
  response = await mainServer.instance.get("/patientproduct/products", {params:{...params}})
  return response.data.data.products
}





export const request_diagnostics = async(id) => {
  const logData = JSON.parse(localStorage.getItem('data'))
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token
  let response
  response = await mainServer.instance.get(
    "/patientproduct/diagnostics", 
    {params:{
      productid:id
    }}
  )
  return response.data.data.diagnostics
}

///////////////////////////////  BENEFITS  ///////////////////////////////////////////


export const request_recalculate_benefit = async (id) => {  
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  const url = '/patient/'+id+'/benefit'
  await mainServer.instance.post(url)
  let response = await mainServer.instance.get(`/patientproduct/patient/${id}`)
  return response.data.data.patient_products
}



///////////////////////////////  PATIENT PRODUCTS  ///////////////////////////////////////////

export const request_patientproducts = async (id) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response = await mainServer.instance.get(`/patientproduct/patient/${id}`, {params:{order_by:'id_patient_product', order:0}})
  return response.data.data.patient_products
}

export const request_edit_patient_product = async (id, product_id, data) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  await mainServer.instance.patch('patientproduct/'+product_id, data)
  let response = await mainServer.instance.get(`/patientproduct/patient/${id}`)
  return response.data.data.patient_products
}

export const request_delete_patient_product = async (id, patient_product_id) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  await mainServer.instance.delete('patientproduct/'+patient_product_id)
  let response = await mainServer.instance.get(`/patientproduct/patient/${id}`)
  return response.data.data.patient_products
}

export const request_change_benefit = async (id, data, product_id) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  await mainServer.instance.post( `/patientproduct/${product_id}/manualbenefit`, data)
  let response = await mainServer.instance.get(`/patientproduct/patient/${id}`)
  return response.data.data.patient_products
}

export const request_add_patient_product = async (id, data) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response = await mainServer.instance.post('patientproduct/', data)
  return response.data.data.patient_product_id
}

export const request_recalculate_benefit_by_product = async (id, idproduct) => {  
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  const url = '/patient/'+id+'/benefit/product/'+idproduct
  await mainServer.instance.post(url)
  let response = await mainServer.instance.get(`/patientproduct/patient/${id}`)
  return response.data.data.patient_products
}




export const request_send_approval = async (id) => {
  const logData = JSON.parse(localStorage.getItem('data'))
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token
  let url = '/patient/'+id+'/sendforapproval'
  await mainServer.instance.post(url)
}

export const request_providers = async () => {
  const logData = JSON.parse(localStorage.getItem('data'))
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token
  let response
  response = await mainServer.instance.get("/provider/all")
  return response.data.data.providers
}

export const request_download_file = async(id, path) => {
  const url = '/patient/'+id+'/'+path
  let response = await mainServer.instance.get(url, {responseType: 'blob'});
  FileSaver.saveAs(response.data, path);
}

export const request_download_provider_letter = async(id) => {
  const url = '/use/'+id+'/providerletter'
  let response = await mainServer.instance.get(url, {responseType: 'blob'});
  console.log(response)
  FileSaver.saveAs(response.data, 'provider-letter');
}

export const request_hospitals = async() => {
  const logData = JSON.parse(localStorage.getItem('data'))
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token
  let response
  response = await mainServer.instance.get("/hospital/all")
  return response.data.data.hospitals
}

////////////////////////// CYCLES //////////////////////////////////

export const request_add_previous_cycle = async (idpatient,data) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  await mainServer.instance.post('/cycle/custom',data)
  let response;
  response = await mainServer.instance.get(`/patientproduct/patient/${idpatient}`)
  return response.data.data.patient_products
}

export const request_edit_previous_cycle = async (idpatient,idcycle,data) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  await mainServer.instance.patch(`/cycle/${idcycle}/custom`,data)
  let response;
  response = await mainServer.instance.get(`/patientproduct/patient/${idpatient}`)
  return response.data.data.patient_products
}

export const request_create_cycle = async (idpatient,data,type) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let url = ''
  if(type === BENEFIT_TYPE.NORMAL) url = '/cycle'
  if(type === BENEFIT_TYPE.ROACTERMA) url = '/cycle/annual'
  if(type === BENEFIT_TYPE.INTERMITENT) url = '/cycle/intermittent'
  //const url = type === BENEFIT_TYPE.NORMAL ? '/cycle' : '/cycle/annual'
  await mainServer.instance.post(url,data)
  let response;
  response = await mainServer.instance.get(`/patientproduct/patient/${idpatient}`)
  return response.data.data.patient_products
}

export const request_update_cycle = async(idpatient, idcycle, data) => {
  const logData = JSON.parse(localStorage.getItem('data'))
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token
  let response
  await mainServer.instance.patch(`/cycle/${idcycle}`, data)
  response = await mainServer.instance.get(`/patientproduct/patient/${idpatient}`)
  return response.data.data.patient_products
}

export const request_delete_cycle = async (idpatient,idcycle) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  await mainServer.instance.delete(`/cycle/${idcycle}`)
  let response;
  response = await mainServer.instance.get(`/patientproduct/patient/${idpatient}`)
  return response.data.data.patient_products
}

export const request_update_all_cycles = async (id, type) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let url = type === BENEFIT_TYPE.NORMAL ? `/patient/${id}/updatecycles` : `/patient/${id}/updatecycles/yearly`
  await mainServer.instance.post( `/patient/${id}/updatecycles`)
  let response = await mainServer.instance.get(`/patientproduct/patient/${id}`)
  return response.data.data.patient_products
}


export const request_cycles = async (id) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  let response;
  response = await mainServer.instance.get("/cycle/patientproduct/"+id);
  return response.data.data.cycles
}

////////////////////////// USES //////////////////////////////////

export const request_update_use = async (idpatient, iduse, data) => {
  const logData = JSON.parse(localStorage.getItem('data'));
  mainServer.instance.defaults.headers.common['Authorization'] = logData.token;
  const url = `/use/${iduse}/update`
  await mainServer.instance.post(url, data)
  let response;
  response = await mainServer.instance.get(`/patientproduct/patient/${idpatient}`)
  return response.data.data.patient_products
  
}